<template>
  <div
    class="page-default bg-dashboard-dark-2 overflow-auto"
    style="height: 100vh"
  >
    <div class="d-flex justify-content-between px-4 py-3">
      <div class="position-relative d-block" style="width: calc(100% - 300px)">
        <div
          class="bg-dark p-2 rounded shadow position-relative d-block overflow-auto"
          style="height: calc(100vh - 80px)"
        >
          <table class="table table-bordered rounded mb-0 table-hover">
            <thead>
              <tr>
                <th
                  style="width: 10px !important"
                  class="fit-content bg-dark border border-outline-dark-all text-white"
                >
                  #
                </th>
                <th
                  style="width: 200px !important"
                  class="fit-content bg-dark border border-outline-dark-all text-white"
                >
                  Date
                </th>
                <th
                  style="width: 200px !important"
                  class="fit-content bg-dark border border-outline-dark-all text-white"
                >
                  Last Access Time
                </th>
                <th
                  style="width: 200px !important"
                  class="fit-content bg-dark border border-outline-dark-all text-white"
                >
                  User
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(log, idx) in userLogs" :key="idx">
                <td>
                  <p class="text-light mb-0">{{ idx + 1 }}</p>
                </td>
                <td>
                  <p class="text-light mb-0">
                    {{ convertDate(log.lastAccess) }}
                  </p>
                </td>
                <td>
                  <p class="text-light mb-0">
                    {{ convertTime(log.lastAccess) }}
                  </p>
                </td>
                <td>
                  <p class="text-light mb-0">
                    {{ log.user.email }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <div
          class="d-flex justify-content-center align-items-center w-100 mt-3"
          v-if="totalPage.length > 1"
        >
          <nav aria-label="Page navigation example ">
            <ul class="pagination m-0 shadow rounded overflow-hidden">
              <li class="page-item" v-for="pg in totalPage" :key="pg">
                <button
                  type="button"
                  class="btn text-white rounded-0"
                  :class="pg == page + 1 ? 'bg-primary' : 'bg-dark'"
                  @click="page = pg - 1"
                >
                  {{ pg }}
                </button>
              </li>
            </ul>
          </nav>
        </div> -->
        </div>
      </div>
      <div class="position-relative d-block ml-2" style="width: 300px">
        <div class="bg-dark p-2 rounded shadow w-100">
          <div class="px-2">
            <h5 class="text-white">Filters</h5>
            <p class="mb-1 text-white mt-3">Date</p>
            <div>
              <v-date-picker
                is-dark
                class="inline-calendar"
                v-model="dateFilter"
                :model-config="{
                  type: 'string',
                  mask: 'YYYY-MM-DD',
                }"
                mode="date"
                trim-weeks
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import API from "@/api";
import moment from "moment";

export default {
  name: "logs",
  data() {
    return {
      dateFilter: moment().format("YYYY-MM-DD"),
      userLogs: [],
      dateFormat: "DD MMMM YYYY",
      timeFormat: "h:mm A",
    };
  },
  watch: {
    async dateFilter() {
      await this.getLogs();
    },
  },
  methods: {
    convertDate(date) {
      return moment(date).format(this.dateFormat);
    },
    convertTime(date) {
      return moment(date).format(this.timeFormat);
    },
    getLogs() {
      this.userLogs = [];
      let params = "";
      let url = new URLSearchParams(params);

      url.set("_sort", "lastAccess:DESC");

      if (this.dateFilter) {
        const _dateFilter = {
          start: moment(this.dateFilter).startOf("day").toISOString(),
          end: moment(this.dateFilter).endOf("day").toISOString(),
        };

        url.set("lastAccess_gte", _dateFilter.start);
        url.set("lastAccess_lte", _dateFilter.end);
      }

      API.get(`userlogs?${url.toString()}`).then((response) => {
        this.userLogs = response.data;
      });
    },
  },
  async mounted() {
    await this.getLogs();
  },
};
</script>
